import { Modal, ModalProps } from 'antd';
import { clsx } from 'clsx';
import { FC } from 'react';

import styles from './styles.module.scss';

export interface ICustomModalProps extends ModalProps {
    onCancel: VoidFunction;
    variant?: 'default' | 'interactive';
    padding?: 'small' | 'default';
}

export const CustomModal: FC<ICustomModalProps> = ({
    variant = 'default',
    padding = 'default',
    ...modalProps
}) => {
    return (
        <Modal
            getContainer={document.body}
            centered={variant === 'default'}
            transitionName={variant === 'interactive' ? 'interactive-modal' : undefined}
            width={650}
            destroyOnHidden
            {...modalProps}
            cancelButtonProps={{
                ...modalProps.cancelButtonProps,
                className: clsx(styles['default-button'], modalProps.cancelButtonProps?.className),
                style: modalProps.cancelButtonProps?.style,
            }}
            classNames={{
                ...modalProps.classNames,
                body: clsx(styles['modal-body'], modalProps.classNames?.body),
                footer: clsx(styles['modal-footer'], modalProps.classNames?.footer),
                mask: clsx(modalProps.classNames?.mask),
            }}
            okButtonProps={{
                htmlType: 'submit',
                ...modalProps.okButtonProps,
                className: clsx(
                    styles['default-button'],
                    styles['ok-button'],
                    modalProps.okButtonProps?.className
                ),
                style: modalProps.okButtonProps?.style,
            }}
            rootClassName={clsx({
                [styles['variant--interactive']]: variant === 'interactive',
                [styles['variant--default']]: variant === 'default',
                [styles['padding--small']]: padding === 'small',
                [styles['padding--default']]: padding === 'default',
            })}
            styles={modalProps.styles}
        />
    );
};
